import { FcGoogle } from 'react-icons/fc';
import { FiArrowRight } from 'react-icons/fi';
import { getRequest } from '~/lib/api';
import EmailAuthModal from './EmailAuthModal';

export default function LoginPanel() {
  const handleGoogleSignIn = async () => {
    const data = await getRequest('/api/v1/auth/google/authorize?app_source=shopify');
    window.location.href = data?.authorization_url;
  };

  const handleMicrosoftSignIn = async () => {
    const data = await getRequest('/api/v1/auth/microsoft/authorize?app_source=shopify');
    window.location.href = data?.authorization_url;
  };

  return (
    <div className="flex flex-col justify-center h-full">
      <fieldset className="fieldset w-full max-w-md mx-auto">
        <legend className="fieldset-legend text-2xl font-semibold mb-2 text-center">
          Get a Free Store Audit
        </legend>

        <p className="text-sm text-center opacity-60 mb-6">
          Give us a week with your data. We'll show you where and how you can improve. It's free, no strings attached.
        </p>

        {/* Primary CTAs - Google/Microsoft */}
        <div className="flex flex-col gap-4 items-center">
          <button
            onClick={handleGoogleSignIn}
            className="btn btn-lg bg-white text-black border-base-300 w-72"
          >
            <FcGoogle size={20} />
            Continue with Google
          </button>
          <button
            onClick={handleMicrosoftSignIn}
            className="btn btn-lg bg-[#2F2F2F] text-white border-black w-72"
          >
            <svg
              width="20"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M96 96H247V247H96" fill="#f24f23" />
              <path d="M265 96V247H416V96" fill="#7eba03" />
              <path d="M96 265H247V416H96" fill="#3ca4ef" />
              <path d="M265 265H416V416H265" fill="#f9ba00" />
            </svg>
            Continue with Microsoft
          </button>
        </div>

        {/* Email auth option */}
        <div className="divider my-4 text-xs opacity-50">or</div>
        <div className="flex justify-center">
          <EmailAuthModal />
        </div>

        {/* Next step hint */}
        <div className="flex items-center justify-center gap-2 mt-6 text-sm opacity-60">
          <span>Next: Connect your store for read-only access</span>
          <FiArrowRight className="w-4 h-4" />
        </div>

        {/* Fine print */}
        <p className="text-xs text-center opacity-40 mt-4">
          Read-only access. Your data is never shared.
        </p>
      </fieldset>
    </div>
  );
}
